import { Image, H4, H6, P, UL, LI } from '../../../../../../AbstractElements';
import { Col, Media, Row } from 'reactstrap';
import React, { Fragment } from 'react';

const InvoiceDetails = ({details}) => {
  return (
    <Fragment>
      <Row className='invo-profile'>
        <Col xl='7' xs='5'>
         
        </Col>
        <Col xl='5' xs='7'>
          <div className='text-md-end'>
            <div id='project'>
              {/* <H6>{"Witte Hospital"}</H6> */}
              <div className='order-box'>
            <UL attrUL={{ className: 'simple-list sub-total total' }}>
              <LI attrLI={{ className: 'border-0 bg-transparent ' }}>
                Total <span className='count'>&#x20B9; {details.sum} <br />
                {/* <p className='text-sm text-info' style={{fontSize: "10px"}}>Included Tax</p> */}
                </span>
                
                {/* Total <span className='count'>$ {getCartTotal(cart)}</span> */}
              </LI>
            </UL>
            <UL attrUL={{ className: 'simple-list sub-total total' }}>
              <LI attrLI={{ className: 'border-0 bg-transparent ' }}>
                Due Amount <span className='count'>&#x20B9; {details.prescription[0]['balance']? details.prescription[0]['balance'] : '-'}</span>
                {/* Total <span className='count'>$ {getCartTotal(cart)}</span> */}
              </LI>
            </UL>
            <UL attrUL={{ className: 'simple-list sub-total total' }}>
              <LI attrLI={{ className: 'border-0 bg-transparent ' }}>
                Previous Paid Amount <span className='count'>&#x20B9; {details.prescription[0]['already_paid']? details.prescription[0]['already_paid'] : '-'}</span>
                {/* Total <span className='count'>$ {getCartTotal(cart)}</span> */}
              </LI>
            </UL>
            </div>
            </div>
          </div>
        </Col>
      </Row>
    </Fragment>
  );
};
export default InvoiceDetails;
